import * as React from "react";
import analytics from "../../../../../utils/analytics";
import BottomSheet from "../BottomSheet/BottomSheet";
import classNames from "classnames";
import useToggle from "../../../../../hooks/useToggle";
import { ReactComponent as CheckPath } from "../../../../../components/atoms/LiveBanner/assets/check.svg";
import Show from "../Show";
import { useParams } from "react-router-dom";
import moment from "moment";

interface Props {
  isLoading: boolean;
  open: boolean;
  onClose: () => void;
  onSubmitData: () => void;
}

const ConfirmationRegistrationForm: React.FC<Props> = ({
  isLoading = false,
  open,
  onClose,
  onSubmitData,
}) => {
  const { active: acceptTnc, toggleActive: toggleAcceptTnc } = useToggle();
  const { city } = useParams();
  const currentYear = moment().format("YYYY");
  const kota = String(`${city?.charAt(0).toUpperCase()}${city?.slice(1)}`);

  const handleSubmitData = () => {
    analytics.sendEvent({ event: "submit_data_registration" });
    if (acceptTnc) {
      onSubmitData();
    }
  };

  const isDisabledButton = !acceptTnc || isLoading;

  return (
    <BottomSheet open={open} onClose={onClose}>
      <div className="p-[16px] flex flex-col gap-y-[8px]">
        <h1 className="leading-[34px] text-[24px] text-[#1F2D3D] font-bold">
          Perjanjian Peserta Piala by.U {currentYear}
        </h1>
        <p className="text-[16px] text-[#1F2D3D] leading-[24px] tracking-[0.08px] text-justify">
          Dengan ini saya menyatakan bahwa data yang saya serahkan adalah benar
          adanya. Apabila terdapat segala bentuk pemalsuan dokumen dan atau
          pemalsuan lainnya, maka saya siap untuk ditindak secara tegas oleh
          panitia sesuai dengan peraturan yang ditetapkan oleh panitia, dan
          ditindak berdasarkan undang-undang yang berlaku di Indonesia. Data
          yang telah diserahkan merupakan sepenuhnya milik dan hak panitia untuk
          menjadikan acuan memilih peserta Piala by.U {kota} {currentYear}.
        </p>

        <div className="flex items-center gap-x-[8px] mt-[8px]">
          <div
            onClick={toggleAcceptTnc}
            className={classNames(
              "w-[24px] h-[24px] border-[#F0F2F9] border-[1px] rounded-[4px]  flex items-center justify-center",
              {
                "bg-[#00BCF1] border-[0px]": acceptTnc,
              }
            )}
          >
            <Show when={acceptTnc}>
              <CheckPath className="scale-[1.4]" />
            </Show>
          </div>
          <p className="text-[14px] text-[#1F2D3D] leading-none relative top-[1px]">
            Saya menyetujui pernyataan tersebut
          </p>
        </div>

        <div className="mt-[16px]">
          <button
            disabled={isDisabledButton}
            onClick={handleSubmitData}
            className={classNames(
              "py-[12px] px-[16px] text-[16px] text-[#fff] w-full rounded-full font-semibold",
              {
                "bg-[#00BCF1]": !isDisabledButton,
                "bg-slate-300": isDisabledButton,
              }
            )}
          >
            {isLoading ? "Loading..." : "Submit Data"}
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ConfirmationRegistrationForm;
